<div class="post-card" [ngClass]="getCardClass()">
  <!-- Post Header -->
  <div class="post-header">
    <div class="user-info-section">
      <div class="avatar-container">
        <img [src]="post.postUserProfile" alt="User Avatar" class="avatar" />
        <div class="online-indicator" *ngIf="isUserOnline"></div>
      </div>
      <div class="user-details">
        <h3 class="username">{{ post.postUsername | titlecase }}</h3>
        <span class="post-time">{{
          getFormattedDateTime(post.postAddDate)
        }}</span>
        <div class="post-visibility" *ngIf="post?.isPublic !== undefined">
          <svg
            class="visibility-icon"
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
            />
          </svg>
          <span>{{ post.isPublic ? "Public" : "Private" }}</span>
        </div>
      </div>
    </div>

    <!-- Update your menu section in the HTML template -->
    <div class="menu-container">
      <button
        class="menu-button"
        (click)="toggleMenu($event)"
        [class.active]="isMenuOpen"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <circle cx="12" cy="5" r="2" />
          <circle cx="12" cy="12" r="2" />
          <circle cx="12" cy="19" r="2" />
        </svg>
      </button>
      <div
        class="menu-dropdown"
        [class.show]="isMenuOpen"
        (click)="$event.stopPropagation()"
      >
        <button class="menu-item" (click)="reportPost($event)">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z" />
          </svg>
          Report post
        </button>
        <button [disabled]="true" class="menu-item" (click)="savePost($event)">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17 3H5c-1.11 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.89-2-2-2z" />
          </svg>
          Save post
        </button>
        <button [disabled]="true" class="menu-item" (click)="hidePost($event)">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
            />
          </svg>
          Hide post
        </button>
      </div>
    </div>
  </div>

  <!-- Post Content -->
  <div class="post-content">
    <div class="post-description" *ngIf="post.postDescription">
      <p [innerHTML]="formatPostDescription(post.postDescription)"></p>
      <button
        class="shared-poll-button"
        *ngIf="post.postShared"
        (click)="onOpenSharePollFn()"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
          />
        </svg>
        Open Shared Content
      </button>
    </div>

    <div class="post-attachment" *ngIf="post.postAttachment">
      <img
        [src]="post.postAttachment"
        alt="Post attachment"
        (click)="openImageModal()"
      />
      <div class="image-overlay" (click)="openImageModal()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
          <path
            d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
          />
        </svg>
      </div>
    </div>

    <!-- Engagement Stats -->
    <div
      class="engagement-stats"
      *ngIf="post.postLikes?.length > 0 || post.postComments?.length > 0"
    >
      <div class="likes-info" *ngIf="post.postLikes?.length > 0">
        <div class="like-avatars">
          <img
            *ngFor="let like of getTopLikers(); let i = index"
            [src]="like.userProfile || defaultAvatar"
            [style.z-index]="10 - i"
            [style.margin-left.px]="i * -8"
            class="like-avatar"
          />
        </div>
        <span class="likes-text">{{ getLikesText() }} </span>
      </div>
      <div class="comments-count" *ngIf="post.postComments?.length > 0">
        {{ post.postComments.length }} comment{{
          post.postComments.length !== 1 ? "s" : ""
        }}
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <button
        class="action-btn like-btn"
        [class.liked]="checkIsLoggedInUserLikedPost()"
        (click)="likePost()"
      >
        <mat-icon>
          {{ checkIsLoggedInUserLikedPost() ? "thumb_up" : "thumb_up_off_alt" }}
        </mat-icon>
        <span>{{ checkIsLoggedInUserLikedPost() ? "Unlike" : "Like" }}</span>
        <span class="likes-count" *ngIf="post.postLikes?.length > 0">
          {{ post.postLikes.length }}
        </span>
      </button>

      <button class="action-btn comment-btn" (click)="focusTextarea()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M21.99 4c0-1.1-.89-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.89 2 2 2h14l4 4-.01-18z"
          />
        </svg>
        <span>Comment</span>
      </button>

      <button
        [disabled]="true"
        class="action-btn share-btn"
        (click)="sharePost()"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z"
          />
        </svg>
        <span>Share</span>
      </button>
    </div>

    <!-- Comments Section -->
    <div class="comments-section" *ngIf="post.postComments?.length > 0">
      <div class="comments-list" [class.expanded]="showAllComments">
        <div
          class="comment-item"
          *ngFor="let comment of getDisplayedComments()"
        >
          <div class="comment-avatar">
            <img
              [src]="comment.commentUserProfile || defaultAvatar"
              alt="Commenter avatar"
            />
          </div>
          <div class="comment-content">
            <div class="comment-bubble">
              <div class="comment-header">
                <span class="comment-author">{{
                  comment.commentUsername | titlecase
                }}</span>
                <span class="comment-time">{{
                  getFormattedDateTime(comment.commentAddDate)
                }}</span>
              </div>
              <p class="comment-text">{{ comment.commentText }}</p>
            </div>
            <div class="comment-actions">
              <button
                *ngIf="false"
                class="comment-action-btn"
                (click)="likeComment(comment)"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    d="M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2z"
                  />
                </svg>
                Like
              </button>
              <button
                class="comment-action-btn"
                (click)="replyToComment(comment)"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    d="M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
                  />
                </svg>
                Reply
              </button>
            </div>
          </div>
        </div>
      </div>

      <button
        class="show-more-comments"
        *ngIf="post.postComments.length > 3 && !showAllComments"
        (click)="toggleAllComments()"
      >
        View all {{ post.postComments.length }} comments
      </button>
    </div>

    <!-- Add Comment -->
    <div class="comment-input-section">
      <div class="comment-input-container">
        <div class="user-avatar">
          <img [src]="loggedIsUsernameProfile" alt="Your avatar" />
        </div>
        <div class="comment-input-wrapper">
          <div
            class="comment-input"
            [class.focused]="isCommentFocused"
            (click)="focusTextarea()"
          >
            <textarea
              #commentTextarea
              [(ngModel)]="commentText"
              (focus)="onCommentFocus()"
              (blur)="onCommentBlur()"
              (keydown)="onKeyDown($event)"
              (input)="onCommentInputCheck($event)"
              placeholder="Write a comment..."
              rows="1"
              [style.height.px]="textareaHeight"
            ></textarea>

            <!-- User mention suggestions -->
            <div class="user-suggestions" *ngIf="showUserList">
              <div
                class="suggestion-item"
                *ngFor="let user of filteredUserOrgList; let i = index"
                [class.selected]="i === selectedIndex"
                (click)="selectUser(user)"
              >
                <img
                  [src]="user.profilePicture || defaultAvatar"
                  alt=""
                  class="suggestion-avatar"
                />
                <div class="suggestion-info">
                  <span class="suggestion-name"
                    >{{ user.firstname }} {{ user.lastname }}</span
                  >
                  <!-- <span class="suggestion-username">{{
                    (user.firstname + user.lastname).toLowerCase()
                  }}</span> -->
                </div>
              </div>
            </div>
          </div>

          <div class="comment-actions" *ngIf="isCommentFocused || commentText">
            <!-- <div class="comment-tools">
              <button
                class="tool-btn"
                (click)="insertEmoji()"
                title="Add emoji"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
                  />
                </svg>
              </button>
              <button
                class="tool-btn"
                (click)="attachFile()"
                title="Attach file"
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
                  />
                </svg>
              </button>
            </div> -->
            <button
              class="send-btn"
              [disabled]="!commentText?.trim()"
              (click)="onCommentInput()"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Image Modal -->
<div class="image-modal" *ngIf="showImageModal" (click)="closeImageModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <button class="modal-close" (click)="closeImageModal()">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path
          d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
        />
      </svg>
    </button>
    <img [src]="post.postAttachment" alt="Full size image" />
  </div>
</div>
